export const playMatchSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = f;
      o.connect(g);
      g.connect(ctx.destination);
      const t = ctx.currentTime + i * 0.14;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.35, t + 0.03);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.45);
      o.start(t);
      o.stop(t + 0.5);
    });
  } catch {}
};

export const vibrateMatch = () => {
  if (navigator.vibrate) navigator.vibrate([300, 120, 300, 120, 600]);
};

export const requestNotifPermission = () => {
  if ("Notification" in window && Notification.permission === "default") {
    Notification.requestPermission().catch(() => {});
  }
};

export const showMatchNotification = (title, body) => {
  if ("Notification" in window && Notification.permission === "granted") {
    try {
      new Notification(title, { body, icon: "/icons/icon-192.png", badge: "/icons/icon-192.png", vibrate: [300, 120, 300] });
    } catch {}
  }
};

export const triggerMatchAlert = (title, body) => {
  playMatchSound();
  vibrateMatch();
  showMatchNotification(title, body);
};
